// extracted by mini-css-extract-plugin
export default {"Table":"Table_Table__JE1QH","caption":"Table_caption__J3nu9","th":"Table_th__bj6Pu","td":"Table_td__I1IRl"};